import {
  Tooltip as _Tooltip,
  UncontrolledTooltip as _UncontrolledTooltip,
  TooltipProps as _TooltipProps,
  UncontrolledTooltipProps as _UncontrolledTooltipProps
} from "reactstrap";

export const Tooltip = _Tooltip;
export const UncontrolledTooltip = _UncontrolledTooltip;

export type TooltipProps = _TooltipProps;
export type UncontrolledTooltipProps = _UncontrolledTooltipProps;
